var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetwork3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9297 19.4447C12.9992 18.457 14.4288 17.8535 15.9994 17.8535C17.57 17.8535 18.9996 18.457 20.0691 19.4447",
    stroke: "#383B41",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2278 23.2096C17.2278 23.8874 16.6784 24.4368 16.0006 24.4368C15.3229 24.4368 14.7734 23.8874 14.7734 23.2096C14.7734 22.5319 15.3229 21.9824 16.0006 21.9824C16.6784 21.9824 17.2278 22.5319 17.2278 23.2096Z",
    fill: "#383B41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14844 12.0966C8.00038 9.46274 11.8127 7.85352 16.001 7.85352C20.1892 7.85352 24.0016 9.46274 26.8535 12.0966M8.53986 15.7706C10.5006 13.9599 13.1216 12.8535 16.001 12.8535C18.8804 12.8535 21.5014 13.9599 23.4621 15.7706",
    stroke: "#E6E9ED",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork3);
export default __webpack_public_path__ + "static/media/network-3.b1097dd6cf10ab2d11ecc726e2002136.svg";
export { ForwardRef as ReactComponent };